import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const ComingSoonDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "rgb(20, 20, 20)", // Dark semi-transparent background
          color: "white",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0px 4px 20px rgba(255, 255, 255, 0.2)", // Soft glow
          maxWidth: "400px",
        }
      }}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.8)", // Dark overlay
        }
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "1.6rem",
          fontWeight: "bold",
          textAlign: "center",
          paddingBottom: "10px",
        }}
      >
        🚀 Coming Soon!
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            textAlign: "center",
            opacity: 0.9,
            marginBottom: "20px"
          }}
        >
          We're working on this feature. Stay tuned for updates!
        </Typography>
      </DialogContent>

      <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: "#f50057", // Pinkish-red
            color: "white",
            fontSize: "1rem",
            padding: "8px 20px",
            borderRadius: "8px",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "#c51162",
              boxShadow: "0px 0px 10px rgba(245, 0, 87, 0.6)"
            }
          }}
          variant="contained"
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComingSoonDialog;
